import React, { useEffect, useState } from "react";
import "./available.css";
import Navbar from "../../Header";
import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { Link } from "react-router-dom";
import api from "../../../api/axios";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import moment from "moment";
function Available() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [ordersPerPage] = useState(10);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await api("GET", "myorders");
      // console.log(response);

      if (Array.isArray(response.data)) {
        setOrders(response.data);
      } else {
        setOrders([]);
      }

      setLoading(false);
    } catch (error) {
      // console.error(error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // Get current orders for pagination
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = Array.isArray(orders)
    ? orders.slice(indexOfFirstOrder, indexOfLastOrder)
    : [];

  // Change page functions
  const nextPage = () => {
    if (currentPage < Math.ceil(orders.length / ordersPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const formatDeadline = (deadline) => {
    const now = moment();
    const end = moment(deadline);
    const duration = moment.duration(end.diff(now));
    const hours = Math.floor(duration.asHours());
    const minutes = Math.floor(duration.minutes());
    return `${hours} hours ${minutes} minutes`;
  };

  return (
    <>
      <Navbar />

      <main className="main-dashboard">
        <div className="dashboard-render">
          <div className="dashboard-render-container available-jobs">
            <p
              style={{
                textAlign: "center",
                fontWeight: "bold",
                fontSize: "21px",
                marginTop: "20px",
              }}
            >
              All Orders
            </p>

            <div className="table-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>Order Name</th>
                    <th>Budget</th>
                    <th>Deadline</th>
                    <th>Category</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td colSpan="4" style={{ textAlign: "center" }}>
                        <AiOutlineLoading3Quarters className="loading-icon" />
                      </td>
                    </tr>
                  ) : currentOrders.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ textAlign: "center" }}>
                        <p style={{ fontWeight: "600" }}>
                          You have no orders yet
                        </p>
                      </td>
                    </tr>
                  ) : (
                    currentOrders.map((order) => (
                      <Link
                        to={`/job-description/${order._id}`}
                        className="table-link"
                        key={order._id}
                      >
                        <tr>
                          <td style={{ fontWeight: "600" }}>
                            {order ? order.title : "N/A"}
                          </td>
                          <td style={{ color: "green", fontWeight: "600" }}>
                            ${order ? order.budget : "N/A"}
                          </td>
                          <td style={{ color: "red", fontWeight: "600" }}>
                            {order
                              ? formatDeadline(order.deadline)
                              : "No deadline"}
                          </td>

                          <td style={{ fontWeight: "600" }}>
                            {order ? order.category : "N/A"}
                          </td>
                          <td style={{ fontWeight: "600" }}>
                            {/* {order ? order.status : "N/A"} */}
                            {order.status || "N/A"}
                          </td>
                        </tr>
                      </Link>
                    ))
                  )}
                </tbody>
              </table>
              <div className="pagination">
                <MdKeyboardDoubleArrowLeft
                  className={`pagination-icon ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={prevPage}
                />
                <span className="pagination-number">{currentPage}</span>
                <MdKeyboardDoubleArrowRight
                  className={`pagination-icon ${
                    currentOrders.length < ordersPerPage ? "disabled" : ""
                  }`}
                  onClick={nextPage}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Available;
